import { MaintenanceDetailsState } from '@hkm/components/Maintenance/Details/domain/interfaces';
import { Store } from '@hkm/store/interfaces/store';

export const selectMaintenanceDetailsState = (state: Store): MaintenanceDetailsState => state.maintenanceDetails;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Details/domain/selectors.ts